import React, { Component } from 'react';

class SearchForm extends Component
{
    constructor(props)
    {
        super(props);

        this.value = null;
        this.onChange = props.onChange;
        this.search = this.search.bind(this);
        this.handleInput = this.handleInput.bind(this);
        this.enter = this.enter.bind(this);

    }

    handleInput(event)
    {
        this.value = event.target.value;
    }

    search()
    {
        this.onChange(this.value);
    }

    enter(e)
    {
        if(e.key == "Enter")
        {
            e.preventDefault();
            this.onChange(this.value);
        }
    }

    render()
    {
        return (
            <div>
                <div className="row">
                    <div className="col-lg-8 col-sm-12">
                        <div className="form-group">
                            <input type="text" className="form-control" name="search" onChange={ this.handleInput } onKeyPress={ this.enter } defaultValue={ this.props.value }
                             placeholder="Par Nom, Téléphone, Email, Adresse, Siret, IMMAT, N°de serie(VIN)"/>
                        </div>
                    </div>
                    <div className="col-lg-4 col-sm-12">
                        <button className="btn btn-primary" style={{"width" : "100%"}} onClick={ this.search }  ><li className="fas fa-search"> </li> Rechercher</button>
                    </div>
                </div>
            </div>
        );
    }
}

export default SearchForm;


// WEBPACK FOOTER //
// ./src/Components/Search/SearchForm.js